import axios from 'axios';

export default class WebhookService {
    constructor(http, store) {
        this._http = http;
        this._store = store;
    }

    async listarWebhooks(params) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + 'webhooks',
                {
                    params: params,
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async buscarDetalhes(id) {
        try {
            const response = await axios.get(
                process.env.VUE_APP_RECUPERI_API + `webhooks/${id}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async executarDispatcher(payload = {}) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'webhooks/dispatcher/run',
                payload,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async executarWatchdog(payload = {}) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'webhooks/watchdog/run',
                payload,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async executarCleanup(payload = {}) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'webhooks/cleanup/run',
                payload,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async reprocessarWebhook(id) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + `webhooks/${id}/reprocessar`,
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }

    async reprocessarLote(payload) {
        try {
            const response = await axios.post(
                process.env.VUE_APP_RECUPERI_API + 'webhooks/reprocessar-lote',
                payload,
                {
                    headers: {
                        Authorization: 'Bearer ' + this._store.getters.token
                    }
                }
            );
            return response.data;
        } catch (error) {
            throw error?.response;
        }
    }
}
